import * as actionTypes from "./actionTypes";
import * as types from "./types";

// GET User

const initialProfile: types.IProfileState = {
    pending: false,
    profile: [],
    error: null,
};

export const ProfileReducer =  (state = initialProfile, action: types.ProfileActions) => {
    switch (action.type) {
        case actionTypes.FETCH_PROFILE_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_PROFILE_SUCCESS:
            return {
                ...state,
                pending: false,
                profile: action.payload.profile,
                error: null,
            };
        case actionTypes.FETCH_PROFILE_FAILURE:
            return {
                ...state,
                pending: false,
                profile: [],
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

